7<template>
    <v-app id="inspire">
      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

       <v-container fluid fill-height align-start>
          <v-row>
            <v-col md="12" lg="12" cols="12">
              <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Mesas {{negocio.negocio}}</h1>
              <br/>
            <v-alert
            :value="alertborrador"
            color="red"
            dark
            dismissible
            border="top"
            transition="scale-transition"
          >
          Su Mesa se borro con éxito.
           </v-alert>
           <v-alert
            :value="alertnuevo"
            color="primary"
            dark
            dismissible
            border="top"
            transition="scale-transition"
          >
          Su Mesa se agrego con éxito.
           </v-alert>
           <v-alert
            :value="alerteditar"
            color="green"
            dark
            dismissible
            border="top"
            transition="scale-transition"
          >
          Su Mesa se edito con éxito.
           </v-alert>
            <v-data-table
          :headers="headers"
          :items="Mesas"
          sort-by="espacioId"
          sort-desc
          class="elevation-1"
          :search="search"
          loading-text="Cargando... Por favor espere"

          style="background-color: #393E46;"
        >
          <template v-slot:top>
            <v-toolbar flat >
              <v-toolbar-title>Mesas</v-toolbar-title>
              <v-progress-circular
            indeterminate
            v-if="progr == true"
            color="primary"
          ></v-progress-circular>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Mesa</v-btn>
                </template>
                <v-card color="#393E46">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="12">
                          <v-text-field v-model="editedItem.espacio" label="Nombre"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                          <v-text-field v-model="editedItem.precio"   type="number" label="Costo" append-outer-icon="fas fa-plus" @click:append-outer="increment" prepend-icon="fas fa-minus" @click:prepend="decrement" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-autocomplete
                v-model="editedItem.zonaNegocio"
                :items="Zonas"
                item-text="zona"
                item-value="id"
                label="Escoge Zona"
                persistent-hint
                return-object
                single-line
              ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogdelete" persistent max-width="350">
            <v-card>
              <v-card-title class="headline">Desea eliminar esta Mesa?</v-card-title>
              <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="close">No</v-btn>
                <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              fas fa-edit
            </v-icon>
            <v-icon
              small
              color="error"
              @click="deleteItem(item)"
            >
              fas fa-minus-circle
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="damemesas">Cargar de Nuevo</v-btn>
          </template>
        </v-data-table>
          </v-col>
        </v-row>
        <leftmenu :abreviado="abreviado" />
      </v-container>
     </v-main>
    </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import md5 from "js-md5";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Mesas | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {  },
      progr: true,
      abreviado:'NN',
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      token:'',
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Mesas-Box',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Mesas: [],
      Zonas: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        espacio: '',
        precio: 0,
        cantidad:0,
        movible: true,
        zonaNegocio : {}
    },
    defaultItem: {
      espacio: '',
      precio: 0,
      movible: true,
      cantidad:0,
      zonaNegocio : {}
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Mesa', align: 'left',  value: 'espacio'},
        { text: 'Zona', value: 'zonaNegocio.zona' },
        { text: 'Valor', value: 'precio' }
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
              if (this.usuario.id === undefined){

                this.overlay = true
                firebase
                    .auth()
                    .onAuthStateChanged(user => {
                      if(user){
                        this.overlay = false
                        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                        this.damemesas();
                        this.dameZonas();
                      }else{
                        this.overlay = false
                        this.$router.push({ path: '/' });
                      }
                    })
         }else{
                this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                this.damemesas();
                this.dameZonas();
              }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.cliente": function (){
       this.damemesas();
       this.dameZonas();
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio;
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){

        this.$router.push({ path: '/' });
            }else{
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

        this.damemesas();
        this.dameZonas();
      }
    },
  },
  methods : {
    damemesas(){
      this.progr = true;
            let urMesa = 'espacios/negocio/zonatag/' + this.idnegocio ;
        axios
        .get(urMesa,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Mesas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },
     increment () {
      this.editedItem.precio = parseInt(this.editedItem.precio,10) + 1
    },
    decrement () {
      this.editedItem.precio = parseInt(this.editedItem.precio,10) - 1
    },
    dameZonas(){
      this.progr = true;
      let urlZona = 'zonas/negocio/' + this.idnegocio ;
        axios
        .get(urlZona,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Zonas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },
    editItem (item) {
      this.editedIndex = this.Mesas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Mesas.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      let md555 = md5(this.Mesas[this.editedIndex].espacioId.toString());
      axios
      .delete('espacios/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.Mesas = response.data;
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Mesas[this.editedIndex], this.editedItem);
        var bodyFormData2 = new FormData();
        this.editedItem.name = this.editedItem.espacio;

        bodyFormData2.append("data",JSON.stringify(this.editedItem));

       axios
      .post('espacios/negocio/grabar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
         this.Mesas = response.data;
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();

        this.editedItem.name = this.editedItem.espacio;

        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('espacios/negocio/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {

          this.Mesas = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Mesa' : 'Editar Mesa'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
